export default "__VITE_ASSET__Clh87oeH__"